// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
}

.messages-list {
  flex: 1;
  overflow-y: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.message-bubble {
  max-width: 70%;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.2s ease;
}

.message-bubble:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.user-message {
  align-self: flex-end;
  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);
  color: white;
}

.bot-message {
  align-self: flex-start;
  background-color: #F1F5F9;
  color: #0F172A;
  border: 1px solid #E2E8F0;
}

.message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
}

.message-sender {
  font-weight: 600;
}

.user-message .message-sender {
  color: rgba(255, 255, 255, 0.95);
}

.bot-message .message-sender {
  color: #0EA5E9;
}

.message-timestamp {
  opacity: 0.7;
  font-size: 0.75rem;
}

.message-text {
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* react-markdown rendered elements inside bot messages — undo pre-wrap so the
   markdown parser controls layout, and tighten the heavy browser defaults on
   lists/paragraphs so the chat bubble reads cleanly. User messages keep
   pre-wrap above so multi-line user input is preserved verbatim. */
.bot-message .message-text {
  white-space: normal;
}

.bot-message .message-text p {
  margin: 0 0 0.5rem 0;
}

.bot-message .message-text p:last-child {
  margin-bottom: 0;
}

.bot-message .message-text ul,
.bot-message .message-text ol {
  margin: 0.25rem 0 0.5rem 0;
  padding-left: 1.25rem;
}

.bot-message .message-text li {
  margin: 0.15rem 0;
  line-height: 1.55;
}

.bot-message .message-text li > p {
  margin: 0;
}

.bot-message .message-text code {
  background-color: rgba(15, 23, 42, 0.06);
  padding: 0.1rem 0.3rem;
  border-radius: 4px;
  font-size: 0.9em;
}

.bot-message .message-text pre {
  background-color: rgba(15, 23, 42, 0.06);
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  overflow-x: auto;
  margin: 0.5rem 0;
}

.bot-message .message-text strong {
  font-weight: 600;
}

.loading-message {
  opacity: 0.8;
}

.typing-indicator {
  display: flex;
  gap: 4px;
  align-items: center;
}

.typing-indicator span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #0EA5E9;
  animation: typing 1.4s infinite;
}

.typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.7;
  }
  30% {
    transform: translateY(-10px);
    opacity: 1;
  }
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .messages-list {
    padding: 1rem;
    gap: 0.75rem;
  }
  
  .message-bubble {
    max-width: 85%;
    padding: 0.75rem;
  }
  
  .message-header {
    font-size: 0.8rem;
  }
  
  .message-timestamp {
    font-size: 0.7rem;
  }
}

@media (max-width: 480px) {
  .messages-list {
    padding: 0.75rem;
    gap: 0.5rem;
  }
  
  .message-bubble {
    max-width: 90%;
    padding: 0.65rem;
    border-radius: 10px;
  }
  
  .message-text {
    font-size: 0.9rem;
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MessageContainer/MessageContainer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;mEAGmE;AACnE;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".message-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #ffffff;\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.message-bubble {\n  max-width: 70%;\n  padding: 1rem;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n  transition: box-shadow 0.2s ease;\n}\n\n.message-bubble:hover {\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.user-message {\n  align-self: flex-end;\n  background: linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%);\n  color: white;\n}\n\n.bot-message {\n  align-self: flex-start;\n  background-color: #F1F5F9;\n  color: #0F172A;\n  border: 1px solid #E2E8F0;\n}\n\n.message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  font-size: 0.85rem;\n}\n\n.message-sender {\n  font-weight: 600;\n}\n\n.user-message .message-sender {\n  color: rgba(255, 255, 255, 0.95);\n}\n\n.bot-message .message-sender {\n  color: #0EA5E9;\n}\n\n.message-timestamp {\n  opacity: 0.7;\n  font-size: 0.75rem;\n}\n\n.message-text {\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n/* react-markdown rendered elements inside bot messages — undo pre-wrap so the\n   markdown parser controls layout, and tighten the heavy browser defaults on\n   lists/paragraphs so the chat bubble reads cleanly. User messages keep\n   pre-wrap above so multi-line user input is preserved verbatim. */\n.bot-message .message-text {\n  white-space: normal;\n}\n\n.bot-message .message-text p {\n  margin: 0 0 0.5rem 0;\n}\n\n.bot-message .message-text p:last-child {\n  margin-bottom: 0;\n}\n\n.bot-message .message-text ul,\n.bot-message .message-text ol {\n  margin: 0.25rem 0 0.5rem 0;\n  padding-left: 1.25rem;\n}\n\n.bot-message .message-text li {\n  margin: 0.15rem 0;\n  line-height: 1.55;\n}\n\n.bot-message .message-text li > p {\n  margin: 0;\n}\n\n.bot-message .message-text code {\n  background-color: rgba(15, 23, 42, 0.06);\n  padding: 0.1rem 0.3rem;\n  border-radius: 4px;\n  font-size: 0.9em;\n}\n\n.bot-message .message-text pre {\n  background-color: rgba(15, 23, 42, 0.06);\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  overflow-x: auto;\n  margin: 0.5rem 0;\n}\n\n.bot-message .message-text strong {\n  font-weight: 600;\n}\n\n.loading-message {\n  opacity: 0.8;\n}\n\n.typing-indicator {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.typing-indicator span {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: #0EA5E9;\n  animation: typing 1.4s infinite;\n}\n\n.typing-indicator span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes typing {\n  0%, 60%, 100% {\n    transform: translateY(0);\n    opacity: 0.7;\n  }\n  30% {\n    transform: translateY(-10px);\n    opacity: 1;\n  }\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .messages-list {\n    padding: 1rem;\n    gap: 0.75rem;\n  }\n  \n  .message-bubble {\n    max-width: 85%;\n    padding: 0.75rem;\n  }\n  \n  .message-header {\n    font-size: 0.8rem;\n  }\n  \n  .message-timestamp {\n    font-size: 0.7rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .messages-list {\n    padding: 0.75rem;\n    gap: 0.5rem;\n  }\n  \n  .message-bubble {\n    max-width: 90%;\n    padding: 0.65rem;\n    border-radius: 10px;\n  }\n  \n  .message-text {\n    font-size: 0.9rem;\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
